import { useTranslation } from '@flecto/translations'
import { type CoreInsurance } from '@flecto/types'

export type UseBookingInsuranceStatusOptions = {
  insurance?: CoreInsurance
}

export function useBookingInsuranceStatus({
  insurance,
}: UseBookingInsuranceStatusOptions) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_insurances' })

  const info = {
    color: 'gray',
    label: 'insurance_status_ready',
    status: 'ready',
  }

  switch (insurance?.meta_status) {
    case 'active':
      info.color = 'green'
      info.label = t('insurance_status_active')
      info.status = 'active'
      break

    case 'finished':
      info.color = 'gray'
      info.label = t('insurance_status_finished')
      info.status = 'finished'
      break

    case 'expired':
      info.color = 'gray'
      info.label = t('insurance_status_expired')
      info.status = 'expired'
      break

    case 'within_claim_period':
      info.color = 'blue'
      info.label = t('insurance_status_within_claim_period')
      info.status = 'within_claim_period'
      break

    case 'pending':
      info.color = 'orange'
      info.label = t('insurance_status_pending')
      info.status = 'pending'
      break

    case 'scheduled':
      info.color = 'orange'
      info.label = t('insurance_status_scheduled')
      info.status = 'scheduled'
      break

    case 'canceled':
      info.color = 'red'
      info.label = t('insurance_status_canceled')
      info.status = 'canceled'
      break

    default:
    case 'ready':
      info.color = 'gray'
      info.label = t('insurance_status_ready')
      info.status = 'ready'
      break
  }

  return info
}
